<template>
  <div class="passengersComponent">
    <dropdown ref="dropdown"
              @open="focusInput"
    >
      <div slot="link"
           class="inputText"
      >
        <div v-if="showInputLabel" class="fake_label" @click.stop></div>
        <div class="inputText__group">
          <div class="inputText__icon">
            <i class="fas fa-user"></i>
          </div>
          <input
              @keydown.enter="$refs.dropdown.toggleDropdown()"
              readonly
              v-validate="'required'"
              :data-vv-as="$t('passengers')"
              class="inputText__input"
              type="text"
              :value="formatValue"
              aria-label="passengers"
              aria-describedby="basic-addon1"
              tabindex="0"
              id="passenger-class-btn"
              name="passengers"
          >
          <span class="inputText__feedback">{{ errors.first('passengers') }}</span>
        </div>
      </div>
      <div slot="content" class="searchFlight__passengers">
        <form class="searchFlight__passengersForm surface">
          <div class="searchFlight__passengersContainer">
            <div
                class="double-button"
                v-for="(pax, index) in passengersEnabled"
                :key="'pax' + index"
            >
              <div class="double-button__label">
                <!-- <p>{{ $t(`${passenger.labels[0].label}`) }}</p> -->
                <span>{{ $t(`${pax.ptc}_quantity`) }}</span>
                <span v-if="errors.first(pax.ptc)"
                      class="searchFlight__error"
                >
                  {{ errors.first(pax.ptc) }}
                </span>
              </div>
              <div class="input-group double-button__container">
                <div class="input-group-prepend">
                  <button
                      :id="`${pax.ptc}Minus`"
                      :ref="`${pax.code}Minus`"
                      class="btn btn-outline-gray"
                      tabindex="0"
                      type="button"
                      :disabled="passengerStatus[pax.ptc] === pax.min_quantity"
                      @click="changeCount(pax, -1)"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
                <input
                    class="form-control"
                    v-model="passengerStatus[pax.ptc]"
                    :ref="`pc${pax.ptc}`"
                    :id="`pc-${pax.ptc}`"
                    type="text"
                    :name="pax.ptc"
                    disabled="disabled"
                    :max="pax.max_quantity"
                    placeholder="0"
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    tabindex="0"
                >
                <div class="input-group-append">
                  <button
                      :id="`${pax.ptc}Plus`"
                      class="btn btn-outline-gray"
                      tabindex="0"
                      type="button"
                      @click="changeCount(pax, 1)"
                      :disabled="passengerStatus[pax.ptc] === pax.max_quantity"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
          <!--Hidden until KE-1677 ready-->
          <div class="searchFlight__cabinContainer d-none">
            <div class="inputSelect --sm">
              <label class="inputSelect__label" for="search_cabin">{{$t('cabin')}}</label>
              <div class="inputSelect__group">
                <div class="inputSelect__icon">
                  <i class="fas fa-star"></i>
                </div>
                <select
                    class="inputSelect__input"
                    ref="cabins"
                    v-model="cabin"
                    id="search_cabin">
                  <option>{{ $t('all_cabins')}}</option>
                  <option
                      v-for="option in getCabins"
                      :value="option"
                      :key="option"
                  >
                    {{ $t(`${option}`)}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="searchFlight__formFooter">
            <button
                class="btn btn-primary --sm"
                id="add-pc"
                tab-index="10"
                type="button"
                ref="doneButton"
                :disabled="totalAdults === 0"
                @click="save(true)"
            >{{ $t('done') }}</button>
          </div>
        </form>
      </div>
    </dropdown>
  </div>
</template>

<script>
  import Dropdown from '../Dropdown'

  export default {
    name: 'Passengers',
    components: {
      Dropdown
    },
    props: {
      passengers: { required: true },
      cabins: { required: true },
      value: { required: false },
      preSelected: { required: false },
      showInputLabel: { required: false }
    },
    inject: ['$validator'],
    data () {
      return {
        resultVisible: false,
        visibleLabel: true,
        passengerStatus: null,
        cabin: '',
        passengersEnabledOriginal: null
      }
    },
    mounted () {
      this.passengerStatus = { ADT: 1, CHD: 0, INF: 0 }
      if (this.preSelected) {
        this.passengersEnabled.forEach(pax => {
          this.passengerStatus[pax.code] = this.preSelected.counts[(pax.code).toLowerCase()]
        })
      } else {
        this.passengersEnabled.forEach(pax => {
          if (pax.default_quantity && pax.code === 'ADT' && pax.ptc === 'ADT') {
            if (pax.default_quantity === 0){
              this.passengerStatus[pax.code] = 1
            } else {
              this.passengerStatus[pax.code] = pax.default_quantity
            }
          }
        })
      }
      this.save()
    },
    methods: {
      initializeCounts: function () {
        let passengerStatus = {}
        // hacemos esto para que no pase por referencia
        this.passengersEnabledOriginal = JSON.parse(JSON.stringify(this.passengersEnabled))
        this.passengersEnabled.forEach(passenger => {
          passengerStatus[passenger.ptc] = this.preSelected ? this.preSelected.counts[passenger.ptc.toLowerCase()] : 0
          if (passenger.code === 'ADT' && passenger.ptc === 'ADT') {
            passengerStatus[passenger.ptc] = this.preSelected ? this.preSelected.counts[passenger.ptc.toLowerCase()] : 1
          }
        })
        let i
        for (i in this.passengersEnabled) {
          if (this.passengersEnabled[i]['code'] === 'ADT' && this.passengersEnabled[i]['ptc'] === 'ADT') {
            this.passengersEnabled[i]['min_quantity'] = 1
          } else {
            this.passengersEnabled[i]['min_quantity'] = 0
          }
        }
        this.passengerStatus = passengerStatus
      },
      totalByPax: function (type) {
        let total = 0
        this.passengersEnabled.filter(x => x.code === type).forEach(pax => {
          total += this.passengerStatus[pax.ptc]
        })
        return total
      },
      save: function (closeDropdown) {
        this.errors.clear()
        this.resultVisible = true
        this.visibleLabel = false
        this.$emit('input', {
          counts: {
            adt: this.totalAdults,
            chd: this.totalChild,
            inf: this.totalInfants
          },
          cabin: this.cabin
        })
        if (closeDropdown) {
          this.closeDropdown()
        }
      },
      closeDropdown: function () {
        this.$store.dispatch('notifyOverflowToParent', false)
        this.$refs.dropdown.show = false
      },
      verifyQuanty: function () {
        let cantAdt = 0
        let cantAdtAdt = 0
        let maxQuantityOriginal = 0
        let passengerOrig = this.passengersEnabledOriginal
        this.passengersEnabled.filter(x => x.code === 'ADT' && x.ptc !== 'ADT').forEach(x => {
          cantAdt += this.passengerStatus[x.ptc]
        })
        this.passengersEnabled.filter(x => x.code === 'ADT' && x.ptc === 'ADT').forEach(x => {
          cantAdtAdt += this.passengerStatus[x.ptc]
        })
        if (cantAdt === 0 && cantAdtAdt === 0) {
          this.passengersEnabled.filter(x => x.code === 'ADT' && x.ptc === 'ADT').forEach(x => {
            this.passengerStatus[x.ptc] = 1
          })
        }
        // Si total de Inf == total de Adt no debo permitir que borren adultos
        if (this.totalAdults === this.totalInfants) {
          this.passengersEnabled.filter(x => x.code === 'ADT').forEach(x => {
            x.min_quantity = this.passengerStatus[x.ptc]
          })
        } else {
          this.passengersEnabled.filter(x => x.code === 'ADT' && x.ptc === 'ADT').forEach(x => {
            x.min_quantity = 1
          })
          this.passengersEnabled.filter(x => x.code === 'ADT' && x.ptc !== 'ADT').forEach(x => {
            x.min_quantity = 0
          })
        }
        if (this.totalAdults + this.totalChild >= 9) {
          this.passengersEnabled.filter(x => x.code !== 'INF').forEach(x => {
            x.max_quantity = this.passengerStatus[x.ptc]
          })
        } else {
          this.passengersEnabled.filter(x => x.code !== 'INF').forEach(x => {
            passengerOrig.filter(y => y.id === x.id).forEach(y => {
              maxQuantityOriginal = y.max_quantity
            })
            x.max_quantity = maxQuantityOriginal
          })
        }
        if (this.totalInfants >= this.totalAdults) {
          this.passengersEnabled.filter(x => x.code === 'INF').forEach(x => {
            x.max_quantity = this.passengerStatus[x.ptc]
          })
        } else {
          this.passengersEnabled.filter(x => x.code === 'INF').forEach(x => {
            passengerOrig.filter(y => y.id === x.id).forEach(y => {
              maxQuantityOriginal = y.max_quantity
            })
            if (this.totalAdults > maxQuantityOriginal) {
              x.max_quantity = maxQuantityOriginal
            } else {
              x.max_quantity = this.totalAdults
            }
          })
          let i
          for (i in this.passengersEnabled) {
            if (this.passengersEnabled[i]['code'] === 'ADT' && this.passengersEnabled[i]['ptc'] === 'ADT' && cantAdt === 0) {
              this.passengersEnabled[i]['min_quantity'] = 1
            } else {
              this.passengersEnabled[i]['min_quantity'] = 0
            }
          }
        }
      },
      changeCount: function (pax, operation) {
        this.errors.clear()
        if (operation === 1) {
          /** if is sum **/
          if (this.totalPassengers >= 9 && pax.code !== 'INF') {
            this.errors.add({
              field: pax.ptc,
              msg: this.$t('errors.max_9_pax')
            })
          } else if (pax.code === 'INF' && this.totalAdults <= this.totalInfants) {
            this.errors.add({
              field: pax.ptc,
              msg: this.$t('errors.one_inf_per_adult')
            })
          } else if (pax.code === 'CHD' && this.totalAdults === 0) {
            this.errors.add({
              field: pax.ptc,
              msg: this.$t('errors.at_least_one_adult')
            })
          } else {
            this.passengerStatus[pax.ptc] += 1
          }
          this.passengersEnabled.filter(x => x.code === 'INF').forEach(x => {
            x.max_quantity = this.totalAdults
          })
        } else {
          /** if is diff **/
          if (pax.code === 'ADT') {
            if (this.totalAdults === 1) {
              this.passengersEnabled.filter(x => x.code === 'CHD').forEach(x => {
                this.passengerStatus[x.ptc] = 0
              })
            }
            if (this.totalAdults === this.passengerStatus['INF']) {
              this.passengersEnabled.filter(x => x.code === 'INF').forEach(x => {
                if (this.passengerStatus[x.ptc] > 0) {
                  this.passengerStatus[x.ptc] -= 1
                }
              })
            }
          }
          this.passengerStatus[pax.ptc] -= 1
          this.passengersEnabled.filter(x => x.code === 'INF').forEach(x => {
            x.max_quantity = this.totalAdults
          })
        }
        // if (pax.code === 'ADT') {
        this.verifyQuanty()
        this.save()
        // }
      },
      focusInput: function () {
        this.$store.dispatch('notifyOverflowToParent', true)
        this.$nextTick(() => {
          this.$refs.cabins.focus()
        })
      }
    },
    computed: {
      formatValue: function () {
        // let data = this.value.counts
        // return this.value ? `${this.$t('ADT_quantity')}: ${data.adt} - ${this.$t('CHD_quantity')}: ${data.chd} - ${this.$t('INF_quantity')}: ${data.inf}` : this.$t('passengers')
        return this.value ? this.totalPassengers : this.$t('passengers')
      },
      getCabins: function () {
        let cabins = []
        Object.keys(this.cabins).forEach(key => {
          if (key.includes('_default')) {
            let cabinName = key.replace('_default', '')
            if (this.cabins[cabinName]) {
              cabins.push(cabinName)
            }
          }
        })
        return cabins
      },
      passengersEnabled: function () {
        return this.passengers.filter(x => x.enable)
      },
      totalPassengers: function () {
        return this.totalAdults + this.totalChild + this.totalInfants
      },
      totalAdults: function () {
        return this.totalByPax('ADT')
      },
      totalInfants: function () {
        return this.totalByPax('INF')
      },
      totalChild: function () {
        return this.totalByPax('CHD')
      }
    },
    created () {
      this.initializeCounts()
      let cabinDefSelected = this.preSelected ? this.preSelected.cabin : this.getCabins.find(key => this.cabins[key + '_default'] === true)
      this.cabin = !cabinDefSelected ? 'all_cabins' : cabinDefSelected
    }
  }
</script>


<style lang="sass">
.passengersComponent
  .fake_label
    min-height: 1.7rem
    cursor: default
  .dropdown
    width: 100%
  .double-button
    margin-bottom: 1rem
    display: flex
    width: 100%
    position: relative
    button.btn
      padding: 0 .5rem
      height: 2rem
      font-size: var(--font-size-sm)
      i
        color: var(--color-onSurface) !important
        opacity: 0.5
      &[disabled="disabled"]
        background-color: transparent
        pointer-events: none
        i
          opacity: 0.1
    .form-control
      height: 2rem !important
      border-bottom: 0
      background-color: var(--color-overlay-05)
      border: 1px solid var(--color-overlay-20)
      text-align: center
      color: var(--color-onSurface)
  .searchFlight__formInput
    position: relative
  .double-button__container
    width: 170px
    height: 2rem
    .btn:focus, .btn:active
      border: 1px solid var(--color-primary)
      outline: none
  .double-button__label
    width: 100%
    display: flex
    align-items: left
    overflow: hidden
    font-size: var(--font-size-sm)
.searchFlight__passengers
  position: fixed
  height: 100%
  margin: 0
  right: 0
  left: 0
  top: 0
  display: flex
  width: 100%
  padding: 2rem
  z-index: 99999
  box-shadow: var(--z-1)
  background: var(--color-overlay-60)
  box-sizing: border-box
  transition: opacity 0.2s ease-in
.searchFlight__formFooter
  justify-content: space-between
  display: flex
  padding: 0 1rem 1rem
  .btn
    flex: 1
    margin: 0
    max-width: calc(100% - 0.5rem)
.searchFlight__error
  font-size: 0.7rem
  position: absolute
  top: 23px
  left: 0
  width: calc(100% - 1rem)
  color: red
  line-height: 0.8rem
.searchFlight__passengersContainer
  padding: 1rem 1rem 0
  max-height: 220px
  overflow-y: auto
.searchFlight__cabinContainer
  border-top: 1px solid var(--color-overlay-10)
  padding: 1rem 1rem 0
.searchFlight__passengersForm
  width: 100%
  max-width: 360px
  background: var(--color-surface)
  margin: auto
  left: 0
  right: 0
  border-radius: var(--b-radius-xs)
  box-shadow: var(--z-1)
@media (min-width: 992px)
  .searchFlight__passengersForm
    position: absolute
    margin: 0
    top: -1rem
    width: 260px
  .passengersComponent
    position: relative
  .searchFlight__passengers
    padding: 0
    position: absolute
    background: transparent
    padding: 1rem
  .searchFlight__formFooter
    display: none
</style>
